// extracted by mini-css-extract-plugin
export default {"nomal-remark":"RemarkField_nomal-remark__cRdZd","print-remark":"RemarkField_print-remark__ORhdb"};